var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuisc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6 13.82C24.6 13.82 25.11 14.32 24.6 13.82C23.9164 13.0396 23.5397 12.0374 23.54 11H20.45V23.4C20.4261 24.071 20.1428 24.7066 19.6597 25.1729C19.1766 25.6393 18.5314 25.8999 17.86 25.9C16.44 25.9 15.26 24.74 15.26 23.3C15.26 21.58 16.92 20.29 18.63 20.82V17.66C15.18 17.2 12.16 19.88 12.16 23.3C12.16 26.63 14.92 29 17.85 29C20.99 29 23.54 26.45 23.54 23.3V17.01C24.793 17.9099 26.2973 18.3926 27.84 18.39V15.3C27.84 15.3 25.96 15.39 24.6 13.82Z",
    fill: "#4254EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuisc);
export default __webpack_public_path__ + "static/media/muisc.3617ffbcec8a3e53712f6e6cd17aede7.svg";
export { ForwardRef as ReactComponent };